import { Component, OnInit, OnDestroy } from '@angular/core';
import { FormArray } from '@angular/forms';

import { Subscription } from 'rxjs';

import { ShipmentService } from '../shipment.service';
import { TotalDualVolumePipe, TotalDualWeightPipe, TotalPipe } from '@library/core';
import { IGenericType } from '@library/common/generictype';

@Component({
   selector: 'shipment-calculator',
   templateUrl: './calculator.component.html',
   styleUrls: ['./calculator.component.scss'],
})
export class CalculatorComponent implements OnInit, OnDestroy {

   calculator: FormArray;

   shipmentSub: Subscription;
   calcSub: Subscription;

   itemTotals: IGenericType;

   constructor(
      public shipment: ShipmentService,
      private totalPipe: TotalPipe,
      private weightPipe: TotalDualWeightPipe,
      private volumePipe: TotalDualVolumePipe,
   ) { }

   ngOnInit() {
      this.shipmentSub = this.shipment.shipmentUpdate$.subscribe(( update ) => {
         this.calculator = this.shipment.shipmentForm.get('calculator') as FormArray;
         if ( update ) {
            this.calcSub = this.calculator.valueChanges.subscribe(() => {
               this.itemTotals = {};
               this.itemTotals.pieces = this.totalPipe.transform(this.calculator.getRawValue(), 'pieces');
               this.itemTotals.totalWeight = this.weightPipe.transform( this.calculator.getRawValue() );
               this.itemTotals.totalVolume = this.volumePipe.transform( this.calculator.getRawValue() );
            });

            this.itemTotals = {};
            this.itemTotals.pieces = this.totalPipe.transform(this.calculator.getRawValue(), 'pieces');
            this.itemTotals.totalWeight = this.weightPipe.transform( this.calculator.getRawValue() );
            this.itemTotals.totalVolume = this.volumePipe.transform( this.calculator.getRawValue() );
         }
      });
   }

   ngOnDestroy() {
      this.shipmentSub?.unsubscribe();
      this.calcSub?.unsubscribe();
      this.calculator = null;
   }
}
